module.exports = __webpack_public_path__ + "img/toubu.b08d8753.png";